<era-devices-unassigned-badge-ui [count]="count$ | async"></era-devices-unassigned-badge-ui>